import * as React from 'react';
import {
  ContentPriceContainer,
  ContentOffersViewedContainer,
  ContentOffersCountContainer,
  ContentMortgageContainer,
} from '../ContentSections';
import { Wrapper } from '../../components/Wrapper';
import { Trust } from '../../components/Trust';
import { DetailsContainer } from '../DetailsContainer';
import { HeroContainer } from '../HeroContainer';
import { FiltersContainer } from '../Filters';
import { ExpertViewContainer } from '../ExpertViewContainer';
import { ErrorTooltipContainer } from '../ErrorTooltipContainer';

import { NotDesktop, Desktop } from '../../components/Responsive';
import { ErrorScreen } from '../../components/ErrorScreen';
import { useSelector } from 'react-redux';
import { getIsCrashError } from '../../selectors';

export function Page() {
  const isCrash = useSelector(getIsCrashError);

  return (
    <>
      <HeroContainer />
      <Wrapper>
        {isCrash ? (
          <ErrorScreen />
        ) : (
          <>
            <NotDesktop>
              <ExpertViewContainer />
            </NotDesktop>
            <FiltersContainer />
            <ContentPriceContainer />
            <ContentOffersViewedContainer />
            <Desktop>
              <ExpertViewContainer />
            </Desktop>
            <ContentOffersCountContainer />
            <ContentMortgageContainer />
            <Trust />
            <DetailsContainer />
          </>
        )}
      </Wrapper>
      <ErrorTooltipContainer />
    </>
  );
}
